export default "__VITE_ASSET__DQOcBCj3__"